export const API_URL = process.env.REACT_APP_API_URL;
export const JWTToken = "_mastertrust_";
export const ENV_TEST_NAME = process.env.REACT_APP_TEST_NAME;
export const BULLETIN_URL = process.env.REACT_APP_BULLETIN 